export const SEGMENT_CODE_CREATED_SUCCESSFULLY = 'Segment code created successfully.'
export const SEGMENT_CODE_CREATTION_FAILED = 'Something went wrong, Segment code not created.'
